module.exports = __webpack_public_path__ + "static/img/app_banner.4056ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app_banner.png
// module id = p2S8
// module chunks = 1